import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { useForm } from "react-hook-form";

type MediaFormData = {
  media_name: string;
  media_descr?: string;
  uniq?: string;
  is_available: boolean;
};

interface MediaFormProps {
  initialData?: MediaFormData;
  onSubmit: (data: MediaFormData) => void;
  onCancel: () => void;
}

export function MediaForm({ initialData, onSubmit, onCancel }: MediaFormProps) {
  const form = useForm<MediaFormData>({
    defaultValues: initialData || {
      media_name: "",
      media_descr: "",
      uniq: "",
      is_available: true,
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4 py-4">
        <FormField
          control={form.control}
          name="media_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Media Name</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Enter media name" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="media_descr"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Description (Optional)</FormLabel>
              <FormControl>
                <Textarea {...field} placeholder="Enter media description" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="uniq"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Unique ID (Optional)</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Enter unique identifier" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="is_available"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
              <div className="space-y-0.5">
                <FormLabel className="text-base">Availability Status</FormLabel>
                <div className="text-sm text-muted-foreground">
                  Media will be available for printing when active
                </div>
              </div>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <div className="flex justify-end space-x-2">
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit">
            {initialData ? "Update Media" : "Add Media"}
          </Button>
        </div>
      </form>
    </Form>
  );
}